var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#383A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 14C13.251 14 14.35 12.901 14.35 11.55C14.35 10.199 13.251 9.10001 11.9 9.10001C10.549 9.10001 9.45 10.199 9.45 11.55C9.45 12.901 10.549 14 11.9 14ZM11.9 10.5C12.481 10.5 12.95 10.969 12.95 11.55C12.95 12.131 12.481 12.6 11.9 12.6C11.319 12.6 10.85 12.131 10.85 11.55C10.85 10.969 11.319 10.5 11.9 10.5ZM11.9 15.225C10.262 15.225 7 16.044 7 17.675V18.2C7 18.585 7.315 18.9 7.7 18.9H16.1C16.485 18.9 16.8 18.585 16.8 18.2V17.675C16.8 16.044 13.538 15.225 11.9 15.225ZM8.638 17.5C9.226 17.094 10.647 16.625 11.9 16.625C13.153 16.625 14.574 17.094 15.162 17.5H8.638ZM16.828 15.267C17.64 15.855 18.2 16.639 18.2 17.675V18.9H20.3C20.685 18.9 21 18.585 21 18.2V17.675C21 16.261 18.55 15.456 16.828 15.267ZM16.1 14C17.451 14 18.55 12.901 18.55 11.55C18.55 10.199 17.451 9.10001 16.1 9.10001C15.722 9.10001 15.372 9.19101 15.05 9.34501C15.491 9.96801 15.75 10.731 15.75 11.55C15.75 12.369 15.491 13.132 15.05 13.755C15.372 13.909 15.722 14 16.1 14Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedEmergency);
export default __webpack_public_path__ + "static/media/selected_emergency.c9fd28c00abc1139564090258de43482.svg";
export { ForwardRef as ReactComponent };